import { createSelector } from "reselect";

export const selectSidebar = (state) => state.sidebar;

export const selectSidebarShow = createSelector(selectSidebar, (sidebar) => sidebar.show);
